import { Editor } from "@hugerte/hugerte-react";
import { htmlsEquivalent } from "../../../utils/htmlsEquivalent";
import { usePrimaryColor } from "../../../branding/usePrimaryColor";

interface Props {
  value: string;
  onChange: (next: string) => void;
}

/**
 * HugeRTE editor for FAQ answers. Lean toolbar — no images,
 * fullscreen, or tables, since FAQ answers are short prose with
 * occasional links and lists. Matches the admin FAQ editor's
 * plugin set so existing answers render identically post-save.
 */
export function AnswerEditor({ value, onChange }: Props) {
  const primaryColor = usePrimaryColor();

  return (
    <Editor
      value={value || ""}
      onEditorChange={(content: string) => {
        if (htmlsEquivalent(content, value || "")) return;
        onChange(content);
      }}
      init={{
        height: "100%",
        menubar: false,
        plugins: ["lists", "link", "code", "searchreplace"],
        toolbar:
          "undo redo | blocks | bold italic underline | " +
          "bullist numlist | link | code",
        content_style:
          "body { font-family: 'Inter', system-ui, -apple-system, sans-serif; font-size: 15px; line-height: 1.65; max-width: 720px; margin: 0 auto; padding: 16px; color: #0B2545; } " +
          "p { margin: 0 0 12px; } " +
          `a { color: ${primaryColor}; }`,
        // Preserve author-entered link URLs as typed (e.g. "/contact").
        // HugeRTE's default rewrites them to bare relative paths that
        // break on multi-segment public routes like /landing/:slug.
        convert_urls: false,
        promotion: false,
        branding: false,
        license_key: "gpl",
      }}
    />
  );
}
